module.exports = __webpack_public_path__ + "img/vu.cfc05f82.svg";